<template>
  <span>{{ formattedTweenPrice }}</span>
</template>

<script>
import gsap from 'gsap';

export default {
  name: 'TweenPrice',
  data() {
    return {
      tweenPrice: 0,
    };
  },
  props: {
    price: {
      type: Number,
      default: 0,
    },
    withFormat: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    price: {
      immediate: true,
      handler(price) {
        this.tween(price);
      },
    },
  },
  computed: {
    formattedTweenPrice() {
      if (!this.withFormat) {
        return this.tweenPrice.toFixed(0);
      }

      return this.formatPrice(this.tweenPrice);
    },
  },
  methods: {
    tween(price) {
      gsap.to(this.$data, { duration: 0.5, tweenPrice: price });
    },
  },
};
</script>
